import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

// Pages
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import TendeDaSolePage from "./pages/TendeDaSolePage";
import TendeInternoPage from "./pages/TendeInternoPage";
import PergotendePage from "./pages/PergotendePage";
import BioclimatichePage from "./pages/BioclimatichePage";
import VetratePage from "./pages/VetratePage";
import PreventivePage from "./pages/PreventivePage";
import AreeServitePage from "./pages/AreeServitePage";
import LocationPage from "./pages/LocationPage";
import InstallationsPage from "./pages/InstallationsPage";
import ShopPage from "./pages/ShopPage";
import TessutiPage from "./pages/TessutiPage";
import SmartPage from "./pages/SmartPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Toaster position="top-center" richColors />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/chi-siamo" element={<AboutPage />} />
          <Route path="/tende-da-sole" element={<TendeDaSolePage />} />
          <Route path="/tende-da-interno" element={<TendeInternoPage />} />
          <Route path="/pergotende" element={<PergotendePage />} />
          <Route path="/bioclimatiche" element={<BioclimatichePage />} />
          <Route path="/vetrate-panoramiche" element={<VetratePage />} />
          <Route path="/preventivo" element={<PreventivePage />} />
          <Route path="/aree-servite" element={<AreeServitePage />} />
          <Route path="/aree-servite/:locationId" element={<LocationPage />} />
          <Route path="/installazioni" element={<InstallationsPage />} />
          <Route path="/shop" element={<ShopPage />} />
          <Route path="/tessuti" element={<TessutiPage />} />
          <Route path="/giovanni-tende-smart" element={<SmartPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
